import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CustomerMixin from "@/core/plugins/customer-mixin";
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PUT, CLEAR_ERROR } from "@/core/services/store/request.module";
import DialogBillingAddress from "@/view/pages/customer/create-or-update/Billing-Address.vue";
import Barcode from "@/view/pages/partials/Barcode.vue";
export default {
  mixins: [CustomerMixin],
  data: function data() {
    return {
      formValid: true,
      formLoading: false,
      isFocused: false,
      searchLoader: true,
      customerBilling: null,
      timeoutLimit: 500,
      timeout: null,
      billingAddress: new Object(),
      createBillingDialog: false,
      customerBillingList: new Array()
    };
  },
  watch: {
    customerBilling: function customerBilling(param) {
      if (!param) {
        var _this = this;

        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
          _this.searchCustomerBilling();
        }, _this.timeoutLimit);
      }
    },
    customer: function customer() {
      this.searchCustomerBilling(null);
    }
  },
  props: {
    disabledAutoSelect: {
      type: Boolean,
      default: false
    },
    customerBillingDialog: {
      type: Boolean,
      required: true,
      default: false
    },
    dialogWidth: {
      type: Number,
      default: 768
    },
    customer: {
      type: Number,
      required: true
    }
  },
  components: {
    Dialog: Dialog,
    Barcode: Barcode,
    DialogBillingAddress: DialogBillingAddress
  },
  methods: {
    onEsc: function onEsc() {
      this.resetSearch();
    },
    onEnter: function onEnter() {
      if (this.isSearching) {
        this.searchCustomerBilling();
      }
    },
    onTab: function onTab() {
      if (this.isSearching) {
        this.searchCustomerBilling();
      }
    },
    resetSearch: function resetSearch() {
      var _this = this;

      _this.$nextTick(function () {
        _this.customerBilling = null;
        _this.isFocused = false;
      });
    },
    searchCustomerBilling: function searchCustomerBilling() {
      var _this = this;

      _this.searchLoader = true;

      _this.getCustomerBilling(_this.customer, _this.customerBilling).then(function (response) {
        _this.customerBillingList = response;

        if (!_this.disabledAutoSelect && _this.customerBillingList.length === 1) {
          _this.$emit("selectCustomerBilling", _this.customerBillingList[0].id);
        }
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.createBillingDialog = false;
        _this.searchLoader = false;
      });
    },
    selectCustomerBilling: function selectCustomerBilling(param) {
      this.$emit("selectCustomerBilling", param.id);
    },
    getFormattedBilling: function getFormattedBilling(row) {
      var tempArr = [];

      if (row.unit_no) {
        tempArr.push(row.unit_no);
      }

      if (row.street_1) {
        tempArr.push(row.street_1);
      }

      if (row.street_2) {
        tempArr.push(row.street_2);
      }

      if (row.zip_code) {
        tempArr.push(row.zip_code);
      }

      if (this.lodash.isEmpty(row.city) === false) {
        tempArr.push(row.city.name);
      }

      if (this.lodash.isEmpty(row.state) === false) {
        tempArr.push(row.state.name);
      }

      if (this.lodash.isEmpty(row.country) === false) {
        tempArr.push(row.country.name);
      }

      return tempArr.join(", ");
    },
    updateBilling: function updateBilling(param) {
      this.billingAddress = param;
    },
    createBilling: function createBilling() {
      var _this = this;

      if (!_this.$refs.createBilling.validate()) {
        return false;
      }

      var addressFormData = new Array();
      addressFormData.push(_this.billingAddress);

      var formData = _this.lodash.pickBy(addressFormData, _this.lodash.identity);

      if (_this.lodash.isEmpty(formData) === false) {
        _this.formLoading = true;

        _this.$store.dispatch(CLEAR_ERROR, {});

        _this.$store.dispatch(PUT, {
          url: "address/" + _this.customer,
          data: {
            address: formData
          }
        }).then(function () {
          _this.searchCustomerBilling();
        }).catch(function (error) {
          _this.logError(error);
        }).finally(function () {
          _this.formLoading = false;
        });
      }
    }
  },
  mounted: function mounted() {
    this.searchCustomerBilling();
    this.$refs["search-customer-billing"].focus();
  },
  computed: {
    isSearching: function isSearching() {
      return this.customerBilling && this.customerBilling.length > 0;
    },
    placeholder: function placeholder() {
      return this.isFocused ? "Start Typing then press enter" : "Search Billing Address...";
    }
  }
};